import { Link } from 'react-router-dom';
import { getHotGames } from '@/mocks/games';

export default function HeroBanner() {
  const hotGames = getHotGames();

  return (
    <section className="relative w-full min-h-[420px] md:min-h-[560px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Vibrant%20stylized%20gaming%20world%20collage%20with%20warm%20orange%20and%20amber%20gradient%20background%2C%20abstract%20game%20controller%20silhouettes%2C%20digital%20particles%20floating%2C%20energetic%20atmospheric%20lighting%2C%20clean%20modern%20aesthetic%2C%20no%20text%2C%20cinematic%20wide%20composition%2C%20soft%20glow%20effects%2C%20gaming%20culture%20vibe&width=1800&height=900&seq=hero-bg-gaming-2026&orientation=landscape"
        alt="黄游戏 - 热门游戏推荐与攻略平台"
        title="黄游戏 - 热门游戏推荐与攻略平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-2xl">
          <h1 className="font-heading text-3xl md:text-5xl text-background-50 font-bold leading-tight mb-4">
            探索热门黄游戏
            <br />
            <span className="text-primary-400">畅享游戏无限乐趣</span>
          </h1>
          <p className="text-background-200 text-base md:text-lg mb-8 max-w-xl leading-relaxed">
            汇聚最新黄游戏资讯、热门排行榜、深度攻略与评测内容。无论新手还是资深玩家，都能在这里找到心仪的游戏。
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <Link
              to="/category/rpg"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-colors cursor-pointer whitespace-nowrap text-sm"
            >
              <i className="ri-compass-3-line"></i>
              探索游戏
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-background-50/15 hover:bg-background-50/25 text-background-50 font-medium rounded-lg border border-background-50/30 transition-colors cursor-pointer whitespace-nowrap text-sm"
            >
              了解更多
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>

        <div className="mt-12 hidden md:flex gap-3 flex-wrap">
          {hotGames.slice(0, 6).map((game) => (
            <Link
              key={game.id}
              to={`/article/${game.slug}`}
              className="px-4 py-2 bg-background-50/10 backdrop-blur-sm border border-background-50/20 rounded-full text-sm text-background-100 hover:bg-primary-500/30 hover:border-primary-400/50 transition-all cursor-pointer whitespace-nowrap"
            >
              {game.title}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}